// EditInvoiceModal.jsx
import React from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
  Button,
} from "reactstrap";
import moment from "moment";
import "./Invoices.css";
import "moment/locale/pt-br";
import { NfePanel } from "../../../features/bling";
import {
  calculateProductsTotal,
  formatCurrency,
  formatCurrencyFromCents,
} from "./invoiceParsers";

moment.locale("pt-br");

const EditInvoiceModal = ({
  isOpen,
  toggle,
  invoiceEdit,
  statusMotoboy,
  onChangeStatusMotoboy,
  codeTracking,
  onChangeTrackingCode,
  onSave,
  onAddToCart,
  onFiscalChange,
}) => {
  if (!invoiceEdit || !invoiceEdit.idTransaction) return null;

  const totalProductsEdit = calculateProductsTotal(invoiceEdit);

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-lg">
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <div className="success-screen">
          <div className="thank-you text-center">
            <i className="fa fa-edit" />
            <h1 className="text-white">Edição</h1>
            <strong className="text-white">
              Código de Compra: {invoiceEdit.idTransaction}
            </strong>
          </div>

          {invoiceEdit.products && invoiceEdit.products.length > 0 ? (
            <div className="p-4 p-md-5">
              <Row>
                <Col lg={7} className="text-left mt-4 mt-lg-0">
                  <h6>Endereço de entrega:</h6>
                  <ul className="list-unstyled mb-0">
                    <li>
                      Nome: <strong>{invoiceEdit.delivery?.name}</strong>
                    </li>
                    <li>
                      Endereço:{" "}
                      <strong>
                        {invoiceEdit.delivery?.address?.street},{" "}
                        {invoiceEdit.delivery?.address?.street_number}
                      </strong>
                    </li>
                    {invoiceEdit.delivery?.address?.complementary && (
                      <li>
                        Complemento:{" "}
                        <strong>
                          {invoiceEdit.delivery.address.complementary}
                        </strong>
                      </li>
                    )}
                    <li>
                      Cidade/UF:{" "}
                      <strong>
                        {invoiceEdit.delivery?.address?.city} /{" "}
                        {invoiceEdit.delivery?.address?.state?.toUpperCase()}
                      </strong>
                    </li>
                    <li>
                      CEP:{" "}
                      <strong>{invoiceEdit.delivery?.address?.zipcode}</strong>
                    </li>
                  </ul>
                </Col>

                <Col lg={5} className="text-left mt-4 mt-lg-0">
                  <h6>Resumo da compra:</h6>
                  <ul className="list-unstyled mb-0">
                    <li>
                      <span>Código:</span>{" "}
                      <strong>{invoiceEdit.idTransaction}</strong>
                    </li>
                    <li>
                      <span>Data:</span>{" "}
                      <strong>
                        Dia{" "}
                        {invoiceEdit.dataTransaction
                          ? moment(invoiceEdit.dataTransaction).format("DD")
                          : ""}{" "}
                        de{" "}
                        {invoiceEdit.dataTransaction
                          ? moment(invoiceEdit.dataTransaction).format(
                              "MMMM, YYYY",
                            )
                          : ""}
                        .
                      </strong>
                    </li>
                    <li>
                      <span>Horário:</span>{" "}
                      <strong>
                        {invoiceEdit.dataTransaction
                          ? moment(invoiceEdit.dataTransaction).format("HH")
                          : ""}{" "}
                        horas e{" "}
                        {invoiceEdit.dataTransaction
                          ? moment(invoiceEdit.dataTransaction).format("mm")
                          : ""}{" "}
                        minutos.
                      </strong>
                    </li>
                    <li>
                      <span>Valor total dos produtos:</span>{" "}
                      <strong>{formatCurrency(totalProductsEdit)}</strong>
                    </li>
                    <li>
                      <span>Valor do frete:</span>{" "}
                      <strong>
                        {formatCurrencyFromCents(invoiceEdit.delivery?.fee)}
                      </strong>
                    </li>
                    <li>
                      <span>Valor total do pagamento:</span>{" "}
                      <strong>
                        {formatCurrencyFromCents(invoiceEdit.amount)}
                      </strong>
                    </li>
                  </ul>
                </Col>
              </Row>

              <NfePanel order={invoiceEdit} onChange={onFiscalChange} />

              <Row>
                {invoiceEdit.tracking?.type === "motoboy" ? (
                  <Col lg={12} className="text-left mt-4 mt-lg-0">
                    <div className="form-group">
                      <h6>Status entrega Motoboy:</h6>
                      <select
                        id="statusMotoboy"
                        name="statusMotoboy"
                        value={statusMotoboy}
                        onChange={onChangeStatusMotoboy}
                        className="form-control standard-form-input"
                      >
                        <option value="">
                          Selecione o status atual da entrega do Motoboy
                        </option>
                        <option value="saiu">Saiu para entrega</option>
                        <option value="entregue">Entrega finalizada</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <h6>Detalhes:</h6>
                      {invoiceEdit.tracking?.status_list?.map(
                        (status, index) => (
                          <div key={index} className="mb-2">
                            {status.origem && (
                              <p>
                                <label>Origem:</label> {status.origem}
                              </p>
                            )}
                            {status.destino && (
                              <p>
                                <label>Destino:</label> {status.destino}
                              </p>
                            )}
                            <p>
                              <label>Data:</label> {status.data}
                            </p>
                            <p>
                              <label>Status:</label> {status.status}
                            </p>
                          </div>
                        ),
                      )}
                    </div>
                  </Col>
                ) : (
                  <Col lg={12} className="text-left mt-4 mt-lg-0">
                    <div className="form-group">
                      <h6>Código de rastreamento:</h6>
                      {invoiceEdit.tracking?.code ? (
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          value={invoiceEdit.tracking.code}
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          value={codeTracking}
                          name="code"
                          onChange={onChangeTrackingCode}
                          placeholder="AA123456789BR"
                        />
                      )}
                    </div>

                    <div className="col-12 mt-2 align-center">
                      <Button
                        type="button"
                        onClick={() => onAddToCart(false)}
                        className="btn btn-primary ml-2"
                      >
                        Adicionar ao carrinho
                      </Button>

                      <Button
                        type="button"
                        onClick={() => onAddToCart(true)}
                        className="btn btn-primary ml-2"
                      >
                        Logística Reversa
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          ) : (
            <div>Não existe produtos dessa compra.</div>
          )}
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center pt-4">
        <Button
          type="button"
          onClick={onSave}
          className="btn btn-primary mt-5 mr-2"
        >
          Salvar
        </Button>

        <Button
          type="button"
          onClick={toggle}
          className="btn btn-primary mt-5 mr-2"
        >
          Sair
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditInvoiceModal;
